import React from 'react'
import "./unauthorizedaccess.css"
import ReportProblemIcon from '@mui/icons-material/ReportProblem'

const UnauthorizedAccess = () => {
  return (
    <div className='unauthorizedAccessContainer'>
        <ReportProblemIcon className='reportProbLemIcon'/>
        <span className='unauthorizedAccessMessage'>You are not authorized to visit the page !!!</span>
    </div>
  )
}

export default UnauthorizedAccess